import {
  IAdvertisementBoardModel,
  IAdvertisementBoardsListModel,
  IAdvertisementBoardsSearchFilterModel,
  UploadFileInfoModel,
} from "../../models";
import { SimpleServiceBase } from "../Base";
import { Observable, Observer } from "rxjs";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { HTTP_METHOD } from "../../constants";

export class AdvertisementBoardService extends SimpleServiceBase<
  IAdvertisementBoardModel,
  IAdvertisementBoardsListModel,
  number,
  IAdvertisementBoardsSearchFilterModel
> {
  get url(): string {
    return "/AdBlocksBoards";
  }

  public getUploadFileInfo = (
    adbblockBoardId: number,
    imageNumber: number
  ): Observable<UploadFileInfoModel> =>
    new Observable(
      (observer: Observer<UploadFileInfoModel>) =>
        new AxiosSubscriber(observer, {
          axiosConfig: {
            params: { adbblockBoardId, imageNumber },
          },
          method: HTTP_METHOD.GET,
          url: `${this.url}/GetUploadFileInfo`,
        })
    );
}
